"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const safetybrand03 = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-safetybrand03` : '') + (description ? ` desc-safetybrand03` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-safetybrand03"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-safetybrand03"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.25 7.82a5.389 5.389 0 0 0-9.68 0L5.27 65.45c-.69 1.41-.61 3.07.22 4.41A4.552 4.552 0 0 0 9.35 72h58.11c1.57 0 3.03-.81 3.86-2.14.83-1.33.91-3 .22-4.41L43.25 7.82Z",
    fill: "#FFB499",
    fillOpacity: ".5"
  }), /*#__PURE__*/_react.default.createElement("g", {
    fill: "#F04C24"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7 54.83c-.8 0-1.44.64-1.44 1.44 0 .8.64 1.44 1.44 1.44.8 0 1.44-.64 1.44-1.44 0-.8-.64-1.44-1.44-1.44Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M34.56 46.76c-.55 0-1-.45-1-1v-22.4c0-.55.45-1 1-1s1 .45 1 1v22.4c0 .55-.45 1-1 1Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M63.62 69.16H5.51a5.51 5.51 0 0 1-4.7-2.61 5.517 5.517 0 0 1-.27-5.38L28.83 3.54c1.07-2.17 3.32-3.58 5.74-3.58 2.42 0 4.67 1.4 5.74 3.57L68.6 61.17c.85 1.73.75 3.74-.27 5.38a5.523 5.523 0 0 1-4.7 2.61h-.01Zm-58.11-2h58.11c1.23 0 2.36-.62 3.01-1.67.65-1.04.72-2.33.17-3.44L38.51 4.42a4.424 4.424 0 0 0-3.94-2.46c-1.66 0-3.21.96-3.94 2.46L2.33 62.05c-.54 1.11-.48 2.39.17 3.44a3.518 3.518 0 0 0 3.01 1.67Z"
  })));
};
var _default = exports.default = safetybrand03;